'use strict';

const _ = require('underscore');
const Mn = require('backbone.marionette');
const LinkedNodeItemViewTemplate = require('system/ui/template/detail/linked-node-item.hbs');

const LinkedNodeItemView = Mn.View.extend({
    tagName: 'li',
    className: 'linked-node-item list-item',
    template: LinkedNodeItemViewTemplate,
    events: {
        'click': 'select'
    },

    initialize: function(params) {
        this.node = params.node;
        this.index = params.index;
        this._links = params.links;
        this._diagram = params.diagram;
        this._indexPrefix = params.indexPrefix;
        this.listenTo(this.model, 'change', this.render);
    },

    serializeData: function() {
        const links = _.map(this._links, function(l){
            const source = l.get('source') == this.node;
            let type = l.i18nType();
            // name が設定されていたら type 名を上書き
            if(l.get('name')) {
                type = l.get('name');
            }

            return {
                type: type,
                source: source
            };
        }, this);

        return {
            links: links,
            index: this._indexPrefix + this.index,
            node: this.model.toJSON()
        };
    },

    select: function() {
        this.model.select();
        this.getOption('channel').request('canvas:zoomTo', this.model);
    }
});

/**
 * @exports views/diagram/linked-node-list-view
 */
const LinkedNodeListView = Mn.CollectionView.extend({
    tagName: 'ul',
    className: 'linked-node-list list',
    childView: LinkedNodeItemView,

    childViewOptions: function(child, index) {
        const links = this._links.getLinksHasEdgeOf(
            child.id, this._node.id);
        return {
            index: index + 1,
            indexPrefix: this._indexPrefix,
            node: this._node,
            links: links,
            diagram: this._diagram,
            channel: this.getOption('channel'),
        }
    },

    viewComparator: function(item) {
        const link = this._links.getLinksHasEdgeOf(
            item.id, this._node.id)[0];
        if(!link) {
            return null;
        }
        const meta = this._diagram.getNodeMeta(item.id);
        if(!meta) {
            return null;
        }
        return meta.y;
    },

    initialize: function(params) {
        this._links = params.links;
        this._node = params.node;
        this._diagram = params.diagram;
        this._indexPrefix = params.indexPrefix;
    },

    filter: function(item) {
        const link = this._links.getLinksHasEdgeOf(
            item.id, this._node.id)[0];
        if(!link) {
            return false;
        }
        const meta = this._diagram.getNodeMeta(item.id);
        if(!meta) {
            return false;
        }
        return true;
    }
});

module.exports = LinkedNodeListView;



// WEBPACK FOOTER //
// ./system/ui/view/detail/linked-node-list.js